import { useEffect } from "react";
import * as Scrivito from "scrivito";

import { NavigationProvider } from "^/Context/NavigationContext";
import { MobileNavigationProvider } from "^/Context/MobileNavigationContext";
import Mobile from "./Navigation/Mobile";
import TwoLinesTopNavigation from "./Navigation/TwoLinesTopNavigation";
import OneLineTopNavigation from "./Navigation/OneLineTopNavigation";
import PageNavigation from "./Navigation/PageNavigation";

function Navigation() {
  const currentPage = Scrivito.currentPage();
  const currentPageId = currentPage?.id();

  useEffect(() => {
    if (!currentPageId) return;
    const event = new CustomEvent("closeNavigation");
    window.dispatchEvent(event);
  }, [currentPageId]);

  if (!currentPage) {
    return null;
  }

  const homepage = Scrivito.Obj.root();
  if (!homepage) {
    return null;
  }
  const layout = homepage.get("navigationType") || "two_lines";

  return (
    <NavigationProvider>
      {layout === "two_lines" && (
        <TwoLinesTopNavigation currentPage={currentPage} />
      )}
      {layout === "one_line" && (
        <OneLineTopNavigation currentPage={currentPage} />
      )}
      <PageNavigation />
      <MobileNavigationProvider>
        <Mobile currentPage={currentPage} />
      </MobileNavigationProvider>
    </NavigationProvider>
  );
}

export default Scrivito.connect(Navigation);
